var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ModalContentWrapper, TitleBlock, TitleIcon, } from '../../components/CommonModal/styles';
import { InputField, ActionBlock, DismissText, InviteSectionWrapper, AdminListSectionWrapper, AppAdminItemWrapper, AppAdminItem, AppAdminImage, AppAdminDetails, AppAdminName, AppAdminRole, AppAdminStatus, PendingPill, MailIcon, OrgAccessSectionWrapper, OrgAccessWrapper, OrgIcon, OrgDetails, OrgName, OrgText, EmailWrapper, RoleWrapper, InviteSingleWrapper, AddFormItem, InviteAdminFormHeadings, EmailHeadings, RoleHeadings, ManipulateFormItemWrapper, SmallText, NoPermissionWrapper, AdminListHeading, PermissionCustomWrapper, } from './styles';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@appspotr/ui-kit';
import { connect } from 'react-redux';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faEnvelopeOpenText } from '@fortawesome/pro-regular-svg-icons/faEnvelopeOpenText';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import SelectForModal from '../../components/Forms/Fields/SelectForModal';
import { makeSelectOrganization } from '@project/containers/Root/selectors';
import defaultIcon from '../../images/orgIcon.png';
import { makeAppAdminList } from '../../containers/AppAdmins/selector';
import { listAppAdmins } from '../../containers/AppAdmins/actions';
import { inviteMembers } from '../../store/userInvite/actions';
import { selectMe } from '../../containers/Root/selectors';
import groupsSelector from '../../containers/Admins/selectors';
import { listGroups } from '../../containers/Admins/actions';
import toast from '../../components/Toast';
import { prettyAppGroupName } from '../../utils';
import { PermissionsWrapper } from '../../components/PermissionsWrapper';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { isValidEmail } from '../../components/Forms/FormBuilder/FormValidators';
import { createUser } from '../../store/userImportNew/actions';
import { getRandomColor } from '../utils/getRandomColor';
import { useAppIdFromURL, useOrgIdFromURL } from '../utils/idFromURL';
var InviteAdminModalBody = function (_a) {
    var _b, _c, _d;
    var onCreateUser = _a.onCreateUser, setIsVisible = _a.setIsVisible, organization = _a.organization, appAdmins = _a.appAdmins, me = _a.me, getAppAdmins = _a.getAppAdmins, inviteMembers = _a.inviteMembers, groups = _a.groups, getGroups = _a.getGroups;
    var orgId = useOrgIdFromURL();
    var appId = useAppIdFromURL();
    var _e = useState([
        { id: 0, email: '', role: undefined },
    ]), adminDetailsToAdd = _e[0], setAdminDetailsToAdd = _e[1];
    var createAppAdminInitialState = {
        success: 0,
        error: 0,
        total: 1,
    };
    var _f = useState(createAppAdminInitialState), createAppAdminCounts = _f[0], setCreateAppAdminCounts = _f[1];
    useEffect(function () {
        getAppAdmins(appId);
    }, [getAppAdmins, appId]);
    useEffect(function () {
        getGroups('', false, appId);
    }, [getGroups, appId]);
    // the followings for form design
    var addNewAdminFormElement = function () {
        setAdminDetailsToAdd(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [
            { id: prevState.length, email: '', role: undefined },
        ], false); });
    };
    var removeAdminFormElement = function () {
        setAdminDetailsToAdd(function (prevState) {
            prevState.pop();
            return __spreadArray([], prevState, true);
        });
    };
    // !the above for form design
    // the followings are related to admin creation
    if (createAppAdminCounts.total ===
        createAppAdminCounts.success + createAppAdminCounts.error) {
        createAppAdminCounts.success &&
            toast.success("".concat(createAppAdminCounts.success, " app admins added"), 'invite-admin');
        createAppAdminCounts.error &&
            toast.error("Something went wrong while adding ".concat(createAppAdminCounts.error, " app admins"), 'invite-admin');
        getAppAdmins(appId);
        setCreateAppAdminCounts(createAppAdminInitialState);
        setAdminDetailsToAdd([
            { id: 0, email: '', role: { label: 'Select role', value: undefined } },
        ]);
    }
    var createAppAdmin = function (adminDetail) { return __awaiter(void 0, void 0, void 0, function () {
        var user, groups, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    user = {
                        email: adminDetail === null || adminDetail === void 0 ? void 0 : adminDetail.email,
                        meta: { image_details: getRandomColor() },
                    };
                    groups = [(_a = adminDetail === null || adminDetail === void 0 ? void 0 : adminDetail.role) === null || _a === void 0 ? void 0 : _a.value];
                    return [4 /*yield*/, onCreateUser(user, groups, appId)];
                case 1:
                    result = _b.sent();
                    result
                        ? setCreateAppAdminCounts(function (prevState) { return (__assign(__assign({}, prevState), { success: prevState.success + 1 })); })
                        : setCreateAppAdminCounts(function (prevState) { return (__assign(__assign({}, prevState), { error: prevState.error + 1 })); });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCreateAppAdmin = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setCreateAppAdminCounts(function (prevState) { return (__assign(__assign({}, prevState), { total: adminDetailsToAdd.length })); });
            adminDetailsToAdd.map(function (adminDetail) { return createAppAdmin(adminDetail); });
            return [2 /*return*/];
        });
    }); };
    // !the above are related to admin creation
    // the followings are related to sending mail
    var inviteHandler = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, inviteMembers(userId, appId)];
                case 1:
                    result = _a.sent();
                    if (result) {
                        toast.success('Mail Sent', 'invite-admin');
                    }
                    else {
                        toast.error('Something went wrong while sending mail', 'invite-admin');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // !the above are related to sending mail
    // role select
    var options = [];
    (_b = groups === null || groups === void 0 ? void 0 : groups.groups) === null || _b === void 0 ? void 0 : _b.map(function (group) {
        return options.push({ label: prettyAppGroupName(group.name), value: group.id });
    });
    // group names for admin list
    var getGroupNames = function (appGroups) {
        var groupNames = '';
        appGroups === null || appGroups === void 0 ? void 0 : appGroups.map(function (group) {
            var _a, _b;
            var groupName = prettyAppGroupName((_b = (_a = groups === null || groups === void 0 ? void 0 : groups.groups) === null || _a === void 0 ? void 0 : _a.find(function (g) { return g.id === group; })) === null || _b === void 0 ? void 0 : _b.name);
            groupNames = groupName ? "".concat(groupNames, ", ").concat(groupName) : groupNames;
        });
        return groupNames === null || groupNames === void 0 ? void 0 : groupNames.substring(1);
    };
    // button disabling condition
    var countOfNotFilledFormElements = 0;
    adminDetailsToAdd.map(function (item) {
        var _a;
        (item.email === '' || !isValidEmail(item.email) || !((_a = item === null || item === void 0 ? void 0 : item.role) === null || _a === void 0 ? void 0 : _a.value)) &&
            countOfNotFilledFormElements++;
    });
    return (_jsxs(_Fragment, { children: [_jsxs(TitleBlock, { children: [_jsx("div", { children: "Invite App Admins" }), _jsx(TitleIcon, __assign({ onClick: function () { return setIsVisible(false); } }, { children: _jsx(FontAwesomeIcon, { icon: faTimes }) }))] }), _jsxs(ModalContentWrapper, { children: [_jsx(PermissionsWrapper, __assign({ target: "app:".concat(appId, ":appadmin"), action: "update", AlternateChildren: function () {
                            return (_jsxs(NoPermissionWrapper, { children: [_jsx(FontAwesomeIcon, { icon: faExclamationTriangle }), "You don\u2019t have enough permission to invite App Admins"] }));
                        } }, { children: _jsxs(InviteSectionWrapper, { children: [_jsxs(InviteAdminFormHeadings, { children: [_jsx(EmailHeadings, { children: "Email Address" }), _jsx(RoleHeadings, { children: "Role" })] }), adminDetailsToAdd
                                    .sort(function (a, b) { return (a.id > b.id ? 1 : -1); })
                                    .map(function (adminDetail, index) {
                                    return (_jsxs(InviteSingleWrapper, { children: [_jsx(EmailWrapper, { children: _jsx(InputField, { onChange: function (e) {
                                                        setAdminDetailsToAdd(function (prevState) {
                                                            var _a;
                                                            return __spreadArray(__spreadArray([], prevState === null || prevState === void 0 ? void 0 : prevState.filter(function (item) { return item.id !== index; }), true), [
                                                                {
                                                                    id: index,
                                                                    email: e.target.value,
                                                                    role: (_a = prevState[index]) === null || _a === void 0 ? void 0 : _a.role,
                                                                },
                                                            ], false);
                                                        });
                                                    }, value: adminDetail === null || adminDetail === void 0 ? void 0 : adminDetail.email, placeholder: "Enter email address" }) }), _jsx(RoleWrapper, { children: groups.loading ? (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true, style: { marginTop: '15px' } })) : (_jsx(SelectForModal, { name: "role", value: adminDetail === null || adminDetail === void 0 ? void 0 : adminDetail.role, placeholder: "Select role", options: options, onChange: function (e) {
                                                        setAdminDetailsToAdd(function (prevState) {
                                                            var _a;
                                                            return __spreadArray(__spreadArray([], prevState === null || prevState === void 0 ? void 0 : prevState.filter(function (item) { return item.id !== index; }), true), [
                                                                {
                                                                    id: index,
                                                                    email: (_a = prevState[index]) === null || _a === void 0 ? void 0 : _a.email,
                                                                    role: e,
                                                                },
                                                            ], false);
                                                        });
                                                    }, minHeight: 35, height: 35, style: { width: '160px', marginTop: '4px' }, placeHolderColor: "#C2C2C2" })) })] }, index));
                                }), _jsxs(ManipulateFormItemWrapper, { children: [_jsxs(AddFormItem, __assign({ onClick: addNewAdminFormElement }, { children: [_jsx(FontAwesomeIcon, { icon: faPlus }), _jsx("div", { children: "New Admin" })] })), adminDetailsToAdd.length > 1 && (_jsx(FontAwesomeIcon, { icon: faMinus, style: { cursor: 'pointer' }, onClick: removeAdminFormElement }))] })] }) })), _jsxs(AdminListSectionWrapper, { children: [_jsx(AdminListHeading, { children: "People with App admin access" }), !(appAdmins === null || appAdmins === void 0 ? void 0 : appAdmins.loading) ? (((_c = appAdmins === null || appAdmins === void 0 ? void 0 : appAdmins.appAdminsList) === null || _c === void 0 ? void 0 : _c.length) ? (appAdmins === null || appAdmins === void 0 ? void 0 : appAdmins.appAdminsList.map(function (appAdmin) {
                                var _a, _b, _c, _d;
                                return (_jsxs(AppAdminItemWrapper, { children: [_jsxs(AppAdminItem, { children: [_jsx(AppAdminImage, __assign({ color: ((_a = appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.meta) === null || _a === void 0 ? void 0 : _a.image_details) || '#DADCDE' }, { children: ((_b = appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.meta) === null || _b === void 0 ? void 0 : _b.last_name.replace(/ /g, '')) === ''
                                                        ? (appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.name.replace(/ /g, '')) === ''
                                                            ? appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.email.substring(0, 2)
                                                            : appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.name.replace(/ /g, '').substring(0, 2)
                                                        : "".concat(appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.name.replace(/ /g, '').substring(0, 1)).concat((_c = appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.meta) === null || _c === void 0 ? void 0 : _c.last_name.replace(/ /g, '').substring(0, 1)) })), _jsxs(AppAdminDetails, { children: [_jsxs(AppAdminName, { children: [(appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.name.replace(/ /g, '')) !== ''
                                                                    ? "".concat(appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.name, " ").concat((_d = appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.meta) === null || _d === void 0 ? void 0 : _d.last_name)
                                                                    : appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.email, (appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.id) === me.id && _jsx(_Fragment, { children: " (You)" })] }), _jsx(AppAdminRole, { children: groups.loading ? (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true })) : (getGroupNames(appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.groups)) })] })] }), !(appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.email_verified) && (appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.id) !== me.id && (_jsxs(AppAdminStatus, { children: [_jsx(PendingPill, { children: "Pending" }), _jsx(PermissionsWrapper, __assign({ target: "app:".concat(appId, ":appadmin"), action: "update", hideOnDisable: true, CustomWrapper: PermissionCustomWrapper }, { children: _jsx(MailIcon, __assign({ onClick: function () { return inviteHandler(appAdmin === null || appAdmin === void 0 ? void 0 : appAdmin.id); } }, { children: _jsx(FontAwesomeIcon, { icon: faEnvelopeOpenText }) })) }))] }))] }, appAdmin.id));
                            })) : (_jsx(SmallText, { children: " No app admins found" }))) : (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true }))] }), _jsx(PermissionsWrapper, __assign({ target: "org:".concat(orgId, ":apps"), action: "read", hideOnDisable: true }, { children: _jsxs(OrgAccessSectionWrapper, { children: [_jsx("div", { children: "Organisational Access" }), _jsxs(OrgAccessWrapper, { children: [_jsx(OrgIcon, { children: (organization === null || organization === void 0 ? void 0 : organization.meta) ? (_jsx("img", { src: ((_d = organization === null || organization === void 0 ? void 0 : organization.meta) === null || _d === void 0 ? void 0 : _d.logo) || defaultIcon })) : (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true })) }), _jsxs(OrgDetails, { children: [_jsx(OrgName, { children: (organization === null || organization === void 0 ? void 0 : organization.name) || (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true })) }), _jsx(OrgText, { children: "Able to access and edit the project according to their roles." })] })] })] }) }))] }), _jsx(PermissionsWrapper, __assign({ target: "app:".concat(appId, ":appadmin"), action: "update", hideOnDisable: true }, { children: _jsxs(ActionBlock, { children: [_jsx(DismissText, __assign({ onClick: function () { return setIsVisible(false); } }, { children: "Dismiss" })), _jsx(Button, __assign({ onClick: handleCreateAppAdmin, disabled: !!countOfNotFilledFormElements }, { children: "Send Invitation" }))] }) }))] }));
};
var mapStateToProps = function (state, ownProps) {
    return {
        setIsVisible: ownProps.setIsVisible,
        organization: makeSelectOrganization()(state),
        appAdmins: makeAppAdminList()(state),
        me: selectMe(state),
        groups: groupsSelector(state),
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        getAppAdmins: function (appId) {
            dispatch(listAppAdmins(appId));
        },
        getGroups: function (query, toggleAppGroups, appId) {
            dispatch(listGroups(query, toggleAppGroups, appId));
        },
        inviteMembers: function (userIds, appId) {
            return dispatch(inviteMembers(userIds, appId, ''));
        },
        onCreateUser: function (user, groups, appId) {
            return dispatch(createUser({
                appId: 0,
                user: user,
                sendInviteEmail: true,
                externalUser: true,
                userAppId: appId,
                groups: groups,
                organizationId: '',
            }));
        },
    };
};
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default withConnect(InviteAdminModalBody);
